import DeleteQuestionButton from "./DeleteQuestionButton";

export default DeleteQuestionButton;
